
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
name: "",
props: [""],
data() {
return {
apiurl: "",
loading: false,
mpEnable: 1,
mobileEnable: 1,
smsEnable: 0,
deviceIdData: {}
};
},
components: { Loading, Toast, Checker, CheckerItem },
created() {},

beforeMount() {},

mounted() {
this.$http.get("../static/api/api.json").then(response => {
this.apiurl = response.api;
this.myUrl = location.href.split("#")[0];
this.deviceIdData = JSON.parse(this.$route.params.data);
this.getDevice(this.deviceIdData.deviceId);
});
},
methods: {
getDevice(id){
this.$http
.get(this.apiurl + "/web/device/detail/" + id)
.then(res => {
if (res.code === 0) {
this.mpEnable = res.data.mpEnable
this.smsEnable = res.data.smsEnable
this.mobileEnable = res.data.mobileEnable
}
})
},
onSubmit(values) {
this.sumbits()
},
sumbits() {
this.loading = true;
const postData = {
deviceId: this.deviceIdData.deviceId,
mpEnable: this.mpEnable,
smsEnable: this.smsEnable,
mobileEnable: this.mobileEnable,
};
this.$http
.post(this.apiurl + "/web/device/setting", postData)
.then(res => {
if (res.code === 0) {
this.$vux.toast.text("设置成功", "top");
this.$router.push({
name: "deviceList",
});
} else {
this.$vux.toast.text(res.message, "top");
}
this.loading = false;
});
}
},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/setting.vue